import React, { useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
import AgGrid from "../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { Dropdown } from "primereact/dropdown";
import { getEstadosCategory } from "../../../../../API/Global/Status/StatusRequests";
import { toastShow } from "../../../../../Base/Services/ToastService";
import { confirmDialog } from "primereact/confirmdialog";
import { chageEstadoClasificaciones } from "../../../../../API/Global/Areas/ClasificacionRequest";
import { Toast } from "primereact/toast";

const ClasificacionScreen = ({
  data,
  selected,
  setSelected,
  loading,
  showDialog,
  setShowDialog,
  getInfo,
}) => {
  const { userAuth } = useContext(AuthContext);
  const [estados, setEstado] = useState([])
  const toast = useRef(null)
  
  const ObtenerEstados = async() => {
    const estadosTempo = await getEstadosCategory('General')
    setEstado(estadosTempo.filter(i => i?.IdStatus !== 7))
  }

  
  const changeEstado = ({ data, api }) => {
    return (
      <div>
        <Dropdown
          value={estados.filter((e) => e.IdStatus === data.IdEstado)[0]}
          options={estados}
          optionLabel="StatusName"
          filter
          filterBy="StatusName"
          style={{ width: "100%" }}
          onChange={(e) => {
            let changes = [];
            changes.push({
              IdClasificacion: data.IdClasificacion,
              IdStatus: e.value.IdStatus,
              StatusName: e.value.StatusName,
            });
            confirmDialog({
              message: `¿Cambiar a estado ${e.value.StatusName} a ${changes.length} Clasificación ?`,
              header: "Confirmación",
              icon: "pi pi-exclamation-triangle",
              accept: async () => {
                let IdClasificaciones = changes.map((item) => item.IdClasificacion);
                cambiarEstado(e.value.IdStatus, IdClasificaciones.toString());
                getInfo();
                api.stopEditing();
              },
              reject: () => {},
            });
          }}
        />
      </div>
    );
  };
  
  const cambiarEstado = async (IdStatus, IdClasificaciones) => {
    const result = await chageEstadoClasificaciones({ IdStatus, IdClasificaciones });
    toastShow(toast, "success", "Actualizado", "Estado cambiado exitosamente");
    setSelected([]);
  };
  

  const colums = [
    {
      field: "IdClasificacion",
      header: "ID",
      headerEn: "ID",
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Clasificacion",
      header: "Clasificación",
      headerEn: "Clasification",
      className: "XXlarge",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Descripcion",
      header: "Descripción",
      headerEn: "Description",
      flex: 1,
    },
    {
      field: "UserNameCreated",
      header: "Usuario creo",
      headerEn: "User create",
      className: "small",
    },
    {
      field: "DateCreatedSTR",
      header: "Fecha creo",
      headerEn: "Date create",
      className: "small",
      Format: "Date",
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      className: "small",
      Format: "Estado",
      alignFrozen: "right",
      filter: false,
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
      cellEditor: changeEstado,
      editable: userAuth?.IdRol === 1 || userAuth?.IdRol === 36
    },
    {
      field: "IdArea",
      className: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          tooltipOptions: {
            position: "left",
          },
          onClick: (rowData) => {
            setShowDialog(true);
            setSelected(rowData);
          },
        },
      ],
    },
  ];

  const table = {
    Columns: colums,
    Data: data,
    loading: loading,
  };

  useEffect(() => {
    ObtenerEstados()
  }, []);

  return (
    <div
      className="p-fluid"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast} />
      <AgGrid table={table} />
    </div>
  );
};

export default ClasificacionScreen;
